const CustomProgress = ({
  value,
  bgColor,
  label,
  displayValue,
  handleClick,
}: any) => {
  const Parentdiv = {
    height: "7px",
    width: "100%",
    backgroundColor: "whitesmoke",
    borderRadius: 40,
    cursor: "pointer",
    border: 0,
  };

  const Childdiv = {
    height: "100%",
    width: `${value}%`,
    backgroundColor: bgColor,
    borderRadius: 40,
  };

  return (
    <div>
      <div className="mb-3">
        <span className="text-sm">{label}</span>{" "}
        <span className="float-right">{displayValue || value}</span>
      </div>
      <button
        style={{ width: "100%", backgroundColor: "transparent", border: "0" }}
        onClick={() => handleClick(label)}
      >
        <div style={Parentdiv}>
          <div style={Childdiv}></div>
        </div>
      </button>
    </div>
  );
};

export default CustomProgress;
